import { render, staticRenderFns } from "./GExamCreateQuestionSetting.vue?vue&type=template&id=52648675&scoped=true&"
import script from "./GExamCreateQuestionSetting.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateQuestionSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52648675",
  null
  
)

export default component.exports